export default "__VITE_ASSET__$5_4ZPwz__"